import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { countries, devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Datepicker input
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de ajuste'), // Label for datepicker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Adjustment ID input
                            minWidth: 200,
                            name: 'AdjustmentId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Ajuste'), // Label for adjustment ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Ajuste'), // Placeholder text
                        },
                        {
                            view: 'text', // User ID input
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number',
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label for user ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'richselect', // Movement type selection
                            name: 'TypeMovement',
                            minWidth: 200,
                            label: _('Tipo del movimiento'), // Label for movement type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: 'T', // Default value
                            options: [
                                {
                                    id: 'T',
                                    value: _('Todos'), // Option for all types
                                },
                                {
                                    id: 'E',
                                    value: _('Entrada'), // Option for entry
                                },
                                {
                                    id: 'S',
                                    value: _('Salida'), // Option for exit
                                },
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Permission check
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect2',
                            minWidth: 200,
                            label: "<span class='icon-language'></span>" + _('País'), // Country label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Selected country from profile settings
                            readonly: true,
                            options: {
                                body: {
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value; // Country flag template
                                    },
                                    data: countries, // Country data
                                },
                            },
                            hidden: !devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Permission check
                            css: 'prm-filterByCountry country-hide',
                        },
                        {},
                        {},
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);

                reader.readAsDataURL(file);
            });
        }

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 3 }, // Spacer
                        {
                            view: 'button',
                            value: _('Añadir Puntos Masivamente.'),
                            height: 50,
                            hidden: !devConfig.getPermAction('pointAdjustmentSwitch', 'Switch'),
                            css: 'prm-pointsAdjustmentsAdd',
                            click: () => {
                                webix.ui({
                                    view: 'window',
                                    id: 'BulkAdjustments',
                                    height: 400,
                                    modal: true,
                                    position: 'center',
                                    head: {
                                        view: 'toolbar',
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Añadir Puntos Masivamente.'),
                                                align: 'center',
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close',
                                                click() {
                                                    this.getTopParentView().hide();
                                                },
                                            },
                                        ],
                                    },
                                    body: {
                                        view: 'form',
                                        id: 'subform',
                                        elements: [

                                            // 🔽 ANTES bulkBlock.rows — ahora directo
                                            {
                                                view: "fieldset",
                                                label: _("Subir archivo CSV con múltiples ID"),
                                                body: {
                                                    view: "uploader",
                                                    id: "ExternalIdCsv",
                                                    value: _("Cargar archivo"),
                                                    autosend: false,
                                                    on: {
                                                        onAfterFileAdd(upload) {
                                                            getBase64(upload.file).then((data) => {
                                                                const csvBase64 = data.startsWith("data:")
                                                                    ? data
                                                                    : `data:text/csv;base64,${data}`;

                                                                $$("subform").setValues(
                                                                    { bulkCsvBase64: csvBase64 },
                                                                    true
                                                                );

                                                                webix.message({
                                                                    type: "success",
                                                                    text: _("Archivo cargado correctamente"),
                                                                });
                                                            });
                                                        },
                                                    },
                                                },
                                            },
                                            {
                                                view: "button",
                                                value: _("Confirmar"),
                                                css: "webix_primary",
                                                click() {
                                                    const values = $$("subform").getValues();

                                                    if (!values.bulkCsvBase64) {
                                                        webix.message({
                                                            type: "error",
                                                            text: _("Debes cargar un archivo CSV primero."),
                                                        });
                                                        return;
                                                    }

                                                    this.disable();

                                                    webix.ajax()
                                                        .headers({ "Content-type": "application/json" })
                                                        .post(
                                                            devConfig.geturlApi() + "Report/ModificationPoints",
                                                            JSON.stringify({
                                                                CSV: values.bulkCsvBase64,
                                                                Type: "1",
                                                            }),
                                                            {
                                                                error: () => {
                                                                    webix.message({
                                                                        type: "error",
                                                                        text: _("Error al comunicarse con el servidor."),
                                                                    });
                                                                    this.enable();
                                                                },
                                                                success: (text) => {
                                                                    const response = JSON.parse(text);

                                                                    if (!response.HasError) {
                                                                        webix.message({
                                                                            type: "success",
                                                                            text: _("La operación se realizó exitosamente."),
                                                                        });
                                                                        this.getTopParentView().hide();
                                                                        return;
                                                                    }


                                                                    if (response.error_code === 300190) {
                                                                        errorMsg = _("El archivo no cumple con el contenido requerido.");
                                                                    }
                                                                    if (response.error_code === 300181) {
                                                                        errorMsg = _("El archivo no cumple con el formato.");
                                                                    }

                                                                    webix.message({
                                                                        type: "error",
                                                                        text: errorMsg,
                                                                    });

                                                                    this.enable();
                                                                },
                                                            }
                                                        );
                                                },
                                            },
                                        ],
                                    },
                                }).show();
                            },
                        },
                        {
                            view: 'button', // Button to adjust points
                            value: _('Añadir Puntos Individualmente.'),
                            type: 'form',
                            hidden: !devConfig.getPermAction('pointAdjustmentSwitch', 'Switch'), // Conditional visibility based on permissions
                            css: 'prm-pointsAdjustmentsAdd',
                            click: () => {
                                webix
                                    .ui({
                                        view: 'window', // Modal window for point adjustment
                                        id: 'SubAdjustments',
                                        height: 550,
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _('Añadir Puntos Individualmente.'), // Window title
                                                    align: 'center',
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close window
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center', // Modal is centered on screen
                                        modal: true,        // Enable modal behavior (blocks background)
                                        body: {
                                            view: 'form',
                                            id: 'subform', // Form container for point adjustment
                                            elements: [
                                                {
                                                    view: 'text', // User ID input in modal
                                                    label: _('Usuario Id:'),
                                                    name: 'IdUser',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    type: 'number',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'combo', // Movement type selection in modal
                                                    label: _('Tipo de movimiento:'),
                                                    name: 'TypeMovement',
                                                    id: 'TypeMovement',
                                                    required: true, // Required field
                                                    labelPosition: 'top',
                                                    options: [
                                                        {
                                                            id: 'E',
                                                            value: _('Entrada'), // Option for entry
                                                        },
                                                        {
                                                            id: 'S',
                                                            value: _('Salida'), // Option for exit
                                                        },
                                                    ],
                                                    labelWidth: 150,
                                                },
                                                {
                                                    view: 'text', // Amount of points input in modal
                                                    label: _('Cantidad:'),
                                                    name: 'AmountPoints',
                                                    id: 'AmountPoints',
                                                    type: 'number',
                                                    labelWidth: 150,
                                                    labelPosition: 'top',
                                                    required: true, // Required field
                                                    on: {
                                                        onChange: function (newVal) {
                                                            if (newVal < 0) {
                                                                webix.message({
                                                                    type: 'error',
                                                                    text: 'La cantidad no puede ser negativa.', // Error message for negative input
                                                                });
                                                                this.setValue(''); // Clear input
                                                            }
                                                        },
                                                    },
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button', // Cancel button in modal
                                                            value: _('Cancelar'),
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close window
                                                                $$('subform').setValues(
                                                                    $$('subform').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button in modal
                                                            type: 'form',
                                                            value: _('Guardar'),
                                                            click: function ($e) {
                                                                let values = $$('subform').getValues(); // Get form values
                                                                if ($$('subform').validate()) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json',
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                            'Report/loyaltyPoints',
                                                                            {
                                                                                ...values,
                                                                                ForUserTest: true, // Additional parameter for testing
                                                                            },
                                                                            {
                                                                                error: () => {
                                                                                    webix.message({
                                                                                        type: "error",
                                                                                        text: _("Error al comunicarse con el servidor."),
                                                                                    });
                                                                                    this.enable();
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    var json = JSON.parse(text); // Parse response
                                                                                    if (json.HasError && json.CodeError === 110012) {
                                                                                        return;
                                                                                    }
                                                                                    if (json.HasError) {
                                                                                        webix.message({
                                                                                            type: "error",
                                                                                            text: _("Error al comunicarse con el servidor."),
                                                                                        });
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Puntos Ajustado', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    $$('subform').setValues(
                                                                        $$('subform').getCleanValues(), // Reset form values
                                                                    );
                                                                    this.getTopParentView().hide(); // Close window
                                                                } else {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Completa los campos...', // Error message for validation failure
                                                                        ),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show modal window
                            },
                        },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter', // Shortcut key
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent(
                                    'balanceAdjustments:filter',
                                    [filterdata], // Trigger filter event
                                );
                                $$('b5').collapse(); // Collapse filter section
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and attaches events.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
